var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo-section"},[_c('video',{ref:"video",staticStyle:{"width":"100%"},on:{"canplay":_vm.initCanvas}},[_vm._v(" Stream unavailable ")]),_c('canvas',{ref:"canvas",staticStyle:{"display":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }